export default __webpack_public_path__ + "static/media/Final2x.73636a40.png";